module.exports = __webpack_public_path__ + "114ac2be219d1f15906073c793c88482.svg";